import { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import api, { formatApiError } from "@/lib/api";

const field = "w-full bg-[#080C14] border border-slate-700 rounded px-3 py-2 text-sm text-white focus:border-emerald-500 outline-none transition-colors";

export const ContactForm = () => {
  const [f, setF] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", f);
      setSent(true);
      toast.success("Message sent. We'll get back to you soon.");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  if (sent) return (
    <div className="panel p-6 text-emerald-300" data-testid="contact-form-sent">
      Thanks {f.name}, your message has been sent. We'll reply to {f.email} as soon as possible.
    </div>
  );
  return (
    <form onSubmit={submit} className="panel p-6 space-y-3" data-testid="contact-form">
      <h3 className="font-display text-xl font-bold text-white">Send us a message</h3>
      <div className="grid sm:grid-cols-2 gap-3">
        <input required maxLength={100} value={f.name} onChange={set("name")} placeholder="Your name" className={field} data-testid="contact-form-name" />
        <input required type="email" value={f.email} onChange={set("email")} placeholder="Your email" className={field} data-testid="contact-form-email" />
      </div>
      <textarea required minLength={5} maxLength={4000} rows={5} value={f.message} onChange={set("message")} placeholder="How can we help?" className={field} data-testid="contact-form-message" />
      <Button type="submit" disabled={busy} data-testid="contact-form-submit"><Send className="h-4 w-4 mr-2" />{busy ? "Sending..." : "Send message"}</Button>
    </form>
  );
};
